import { BUTTON_LAYER, OVERLAY_LAYER } from '../../../../common/constants';
import { FONT_FAMILY_BROWN_WITH_FALLBACKS } from '../../../../fonts';
import {
  LABELS_FILL_COLOR,
  METADATA_TEXT_COLOR,
  OVERLAY_COLOR_OPAQUE,
  PRIMARY_FILL_COLOR,
  SIDEBAR_SIZE_LARGE,
  SIDEBAR_SIZE_MEDIUM
} from '../../../theme/colors';

export const ZAP_WRAPPER = {
  position: 'absolute',
  top: '50%',
  right: 0,
  transform: 'translateY(-50%)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: BUTTON_LAYER
};

export const ZAP_GLASS_CONTENT = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  position: 'relative',
  borderRadius: '10px 0px 0px 10px'
};

export const ZAP_CONTENT = {
  default: {
    padding: '12px 8px',
    gap: 16
  },
  smallContainer: {
    gap: 14,
    padding: '8px'
  },
  mediumContainer: {
    padding: '12px 8px'
  }
};

export const ZAP_BUTTON_SIZE_OVERRIDE = {
  width: '100%',
  height: 'inherit',
  cursor: 'pointer'
};

export const ZAP_ICON_SIZE = {
  'smallContainer+extraSmallContainer': { size: 20 },
  mediumContainer: { size: 28 },
  'largeContainer+extraLargeContainer': { size: 32 }
};

export const PANEL_LIVE_OPTION_WRAPPER_STYLE_OPENED = {
  default: {
    background: OVERLAY_COLOR_OPAQUE,
    color: 'white',
    zIndex: OVERLAY_LAYER + 2,
    position: 'absolute',
    right: 0,
    width: `${SIDEBAR_SIZE_MEDIUM}%`
  },
  'largeContainer+extraLargeContainer': {
    width: `${SIDEBAR_SIZE_LARGE}%`
  },
  smallContainer: {
    width: '100%'
  }
};

export const PANEL_TITLE = {
  default: {
    fontSize: 24,
    lineHeight: '24px',
    padding: 16,
    fontWeight: 700,
    color: PRIMARY_FILL_COLOR,
    fontFamily: FONT_FAMILY_BROWN_WITH_FALLBACKS
  },
  smallContainer: { fontSize: 14, padding: 12 },
  'largeTvContainer+extraLargeTvContainer': { fontSize: 32 },
  mediumContainer: { paddingTop: 18 },
  'largeContainer+extraLargeContainer': { paddingTop: 24 }
};

export const PANEL_PROGRAM_TITLE = {
  default: {
    fontSize: 16,
    padding: '2px 16px',
    fontWeight: 700,
    color: PRIMARY_FILL_COLOR,
    fontFamily: FONT_FAMILY_BROWN_WITH_FALLBACKS
  },
  small: { fontSize: 12 },
  'largeTvContainer+extraLargeTvContainer': { fontSize: 24 }
};

export const PANEL_PROGRAM_SUBTITLE = {
  default: {
    fontSize: 14,
    padding: '2px 16px',
    fontWeight: 400,
    color: LABELS_FILL_COLOR,
    fontFamily: FONT_FAMILY_BROWN_WITH_FALLBACKS
  },
  small: { fontSize: 12 },
  'largeTvContainer+extraLargeTvContainer': { fontSize: 20 }
};

export const PANEL_PROGRAM_DESCRIPTION = {
  default: {
    fontSize: 14,
    color: LABELS_FILL_COLOR,
    fontWeight: 400,
    padding: 16,
    fontFamily: FONT_FAMILY_BROWN_WITH_FALLBACKS
  },
  small: { fontSize: 12 },
  'largeTvContainer+extraLargeTvContainer': {
    fontSize: 24,
    color: LABELS_FILL_COLOR,
    padding: 16
  }
};

export const PANEL_PROGRAM_METADATA = {
  default: {
    fontSize: 12,
    padding: '4px 16px',
    fontWeight: 700,
    color: METADATA_TEXT_COLOR,
    fontFamily: FONT_FAMILY_BROWN_WITH_FALLBACKS
  },
  'largeTvContainer+extraLargeTvContainer': { fontSize: 20 }
};

export const PANEL_CLOSE_LABEL = {
  default: {
    position: 'absolute',
    right: 15,
    top: 18
  }
};
export const PANEL_CLOSE_BUTTON = {
  default: {
    width: 'max-content',
    right: 6,
    top: 18
  },
  smallContainer: { top: 15 },
  mediumContainer: { top: 9, right: 9 },
  'largeContainer+extraLargeContainer': { top: 15, right: 15 }
};
export const PANEL_CLOSE_BUTTON_SIZE = { smallContainer: { width: 16 }, default: { width: 24 } };
